var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ConnectionNames } from "../../contracts";
import { decode, decodeAsync } from "@msgpack/msgpack";
import { isFormatMsgPack } from "../../common";
const jsonResponseFormatter = (payload) => {
    const p = JSON.parse(payload.data);
    if ("event" in p && p.event === "unsubscribed") {
        return {
            id: "unsubscribed",
            result: {}
        };
    }
    return {
        id: p.id,
        result: p["data"],
        error: p["error"]
    };
};
const partiallyReadResponse = (decodedResponse) => {
    const [id, event, data, error] = decodedResponse;
    const [code, errorData, message] = (error || []);
    if (event === "unsubscribed") {
        return {
            id: "unsubscribed",
            result: {}
        };
    }
    return {
        id,
        result: data,
        error: error ? {
            code,
            data: errorData,
            message
        } : undefined
    };
};
const msgPackResponseFormatter = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof payload.data.stream === "function" || typeof payload.data.arrayBuffer === "function") {
        try {
            let decodedResponse;
            if (payload.data.stream) {
                decodedResponse = yield decodeAsync(payload.data.stream());
            }
            else {
                const arrayBuffer = yield payload.data.arrayBuffer();
                decodedResponse = decode(arrayBuffer);
            }
            return partiallyReadResponse(decodedResponse);
        }
        catch (e) {
            //this error fill the logs because of unsupported browser and for that reason it is skipped
        }
    }
    return {
        id: "",
        result: {}
    };
});
export function SDQResponseFormatter(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        if (isFormatMsgPack(ConnectionNames.sports)) {
            const res = yield msgPackResponseFormatter(payload);
            return res;
        }
        return jsonResponseFormatter(payload);
    });
}
//# sourceMappingURL=SDQResponseFormatter.js.map